var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpStatusCode } from '@/data/protocols/http';
import { AccessDeniedError, UnexpectedError } from '@/domain/errors';
import { RequestQueryBuilder } from '@nestjsx/crud-request';
export class RemoteManageActivities {
    constructor(url, httpClient) {
        this.url = url;
        this.httpClient = httpClient;
    }
    find(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const httpResponse = yield this.httpClient.request({
                url: `${this.url}?${params.queryBuilder.query()}`,
                method: 'get'
            });
            switch (httpResponse.statusCode) {
                case HttpStatusCode.success:
                    return httpResponse.body;
                case HttpStatusCode.forbidden:
                    throw new AccessDeniedError();
                default:
                    throw new UnexpectedError();
            }
        });
    }
    findByName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryBuilder = RequestQueryBuilder.create();
            queryBuilder.setFilter({ field: 'name', operator: '$eq', value: name });
            const httpResponse = yield this.httpClient.request({
                url: `${this.url}?${queryBuilder.query()}`,
                method: 'get'
            });
            switch (httpResponse.statusCode) {
                case HttpStatusCode.success: {
                    const activities = httpResponse.body;
                    if (activities.length > 0) {
                        return activities[0];
                    }
                    throw new UnexpectedError();
                }
                case HttpStatusCode.forbidden:
                    throw new AccessDeniedError();
                default:
                    throw new UnexpectedError();
            }
        });
    }
    validateUserActivity(params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const httpResponse = yield this.httpClient.request({
                url: `${this.url}/custom/validate-user-activity/idUser/${params.idUser}/nameActivity/${params.activityName}`,
                method: 'get'
            });
            if (httpResponse.statusCode === HttpStatusCode.success) {
                return (_a = httpResponse.body) === null || _a === void 0 ? void 0 : _a.status;
            }
        });
    }
}
